export const site = {
  brand: "新黑料网",
  tagline: "吃瓜社区 · 人物档案 · 事件追踪",
};

export const navLinks = [
  { key: "home", label: "首页", href: "#top" },
  { key: "hotword", label: "今日热议", href: "#hotword" },
  { key: "ranking", label: "热度飙升榜", href: "#ranking" },
  { key: "feed", label: "吃瓜头条", href: "#feed" },
  { key: "people", label: "人物纵深", href: "#people" },
  { key: "trace", label: "当事人档案", href: "#trace" },
  { key: "bbs", label: "围观区", href: "#bbs" },
];

export const peopleCats = ["网红", "明星", "主播", "博主", "当事人"];

export const hotWords = [
  { key: "hw01", text: "#塌房现场谁在带节奏#" },
  { key: "hw02", text: "#主播连麦剧本实锤#" },
  { key: "hw03", text: "#素人一夜涨粉百万#" },
  { key: "hw04", text: "#团队内讧录音流出#" },
  { key: "hw05", text: "#翻红还是翻车#" },
  { key: "hw06", text: "#当事人首次回应#" },
  { key: "hw07", text: "#旧账被翻四年后#" },
  { key: "hw08", text: "#网红转型带货翻车#" },
];

export const leadStory = {
  kicker: "今日头版 · 主编导读",
  title: "一夜爆红的素人，为何三天就被全网围观到底裤？",
  summary:
    "从「无名小卒」到「风口浪尖」只用了72小时。我们试着把涨粉曲线、连麦切片和评论区墙头草一并摊开，看看流量到底是造神，还是设好的局。",
  meta: "专栏 · 8 分钟 · 全网阅读 412 万",
  tags: ["当事人", "网红", "事件复盘"],
};

export const leadSide = [
  {
    id: "ls01",
    cat: "主播",
    title: "连麦起争执，粉丝两拨人吵上热搜前五",
    meta: "2.3 万评",
  },
  {
    id: "ls02",
    cat: "明星",
    title: "一段四年前的旧采访被翻出，评论区两极",
    meta: "1.6 万评",
  },
  {
    id: "ls03",
    cat: "博主",
    title: "带货翻车后晒「道歉信」，网友逐字逐句挑错",
    meta: "9.8 千评",
  },
];

export const rankingItems = [
  { id: "r01", name: "阿诺与团团", kind: "主播", type: "热议中", heat: 98.6, delta: "+3", up: true },
  { id: "r02", name: "陈半糖", kind: "网红", type: "发酵中", heat: 94.2, delta: "+1", up: true },
  { id: "r03", name: "黎九", kind: "博主", type: "新上榜", heat: 91.7, delta: "NEW", up: true },
  { id: "r04", name: "白屿", kind: "当事人", type: "追踪中", heat: 87.3, delta: "-1", up: false },
  { id: "r05", name: "陆轻轻", kind: "明星", type: "热议中", heat: 82.9, delta: "+2", up: true },
  { id: "r06", name: "胡子哥", kind: "主播", type: "发酵中", heat: 79.4, delta: "-2", up: false },
  { id: "r07", name: "小鹿同学", kind: "网红", type: "新上榜", heat: 74.8, delta: "NEW", up: true },
  { id: "r08", name: "周放", kind: "人物", type: "追踪中", heat: 70.1, delta: "-", up: false },
  { id: "r09", name: "佩佩", kind: "博主", type: "发酵中", heat: 66.6, delta: "+1", up: true },
  { id: "r10", name: "老狼电台", kind: "主播", type: "热议中", heat: 61.9, delta: "-3", up: false },
];

export const feedItems = [
  {
    id: "f01",
    cat: "网红",
    title: "「姐妹同心」是剧本？十年闺蜜互晒聊天记录",
    excerpt: "表面上情同手足，背地里各有小号。两家粉丝从互撕到联动吃瓜，直接把旧账全翻了个底朝天。",
    heat: "124.6万",
    hot: true,
    time: "22分钟前",
    tag: "闺蜜翻脸",
    img: "https://readdy.ai/api/search-image?query=Editorial%20documentary%20photo%20of%20two%20young%20chinese%20women%20facing%20each%20other%20across%20a%20table%2C%20tense%20mood%2C%20split%20lighting%20warm%20amber%20and%20cool%20shadow%2C%20film%20grain%2C%20cinematic%20composition%2C%20shallow%20depth%20of%20field&width=1200&height=750&seq=feed01&orientation=landscape",
  },
  {
    id: "f02",
    cat: "主播",
    title: "连麦翻脸名场面：一场「真心话」逼走榜一大哥",
    excerpt: "主播在镜头前把真心话当话术，结果逼走了陪伴三年的榜一大哥。是节目效果，还是亲手拆自己的台？",
    heat: "98.3万",
    hot: true,
    time: "1小时前",
    tag: "连麦名场面",
    img: "https://readdy.ai/api/search-image?query=Streaming%20studio%20set%20with%20ring%20light%20and%20microphone%2C%20empty%20chair%20in%20front%20of%20computer%20screen%2C%20warm%20neon%20accent%20lighting%2C%20editorial%20photography%2C%20moody%20atmosphere%2C%20cinematic%20depth&width=1200&height=750&seq=feed02&orientation=landscape",
  },
  {
    id: "f03",
    cat: "明星",
    title: "「人设崩塌」还是「被断章取义」？旧采访逐帧解读",
    excerpt: "一段六年前的采访被逐帧慢放，字幕剪辑、语气停顿都被拿出来对标。真相也许就藏在删掉的那半句话里。",
    heat: "203.1万",
    hot: true,
    time: "2小时前",
    tag: "逐帧复盘",
    img: "https://readdy.ai/api/search-image?query=Old%20television%20interview%20frame%20grainy%20vintage%20look%2C%20spotlight%20on%20empty%20stage%2C%20warm%20sepia%20tones%2C%20editorial%20mood%2C%20soft%20film%20texture&width=1200&height=750&seq=feed03&orientation=landscape",
  },
  {
    id: "f04",
    cat: "博主",
    title: "带货「道歉信」翻车：网友逐字挑错找到三处漏洞",
    excerpt: "一封看似诚恳的道歉信，被网友标出时间线矛盾、甩锅痕迹与“下次还敢”式收尾，舆论再度反转。",
    heat: "76.8万",
    time: "3小时前",
    tag: "带货翻车",
    img: "https://readdy.ai/api/search-image?query=Scattered%20printed%20documents%20and%20magnifying%20glass%20on%20a%20warm%20wooden%20desk%2C%20editorial%20flat%20lay%2C%20journalistic%20investigation%20mood%2C%20warm%20natural%20light%2C%20high%20detail&width=1200&height=750&seq=feed04&orientation=landscape",
  },
  {
    id: "f05",
    cat: "人物",
    title: "从打工妹到百万粉，她的翻红之路为何被按下暂停",
    excerpt: "普通人的故事最动人，也最容易变成流量剧本。当她的过往被翻出，众人想看的究竟是她，还是戏。",
    heat: "155.4万",
    time: "5小时前",
    tag: "人物起底",
    img: "https://readdy.ai/api/search-image?query=Quiet%20portrait%20of%20young%20chinese%20woman%20working%20at%20city%20night%20window%2C%20reflective%20mood%2C%20warm%20city%20lights%20bokeh%2C%20editorial%20documentary%2C%20cinematic%20soft%20light&width=1200&height=750&seq=feed05&orientation=landscape",
  },
  {
    id: "f06",
    cat: "当事人",
    title: "当年喊话「清者自清」的他，四年后终于改口",
    excerpt: "一句迟到的承认，让四年前的旧帖重新翻红。评论区有人心疼，也有人骂他「早干嘛去了」。",
    heat: "132.7万",
    hot: true,
    time: "6小时前",
    tag: "旧账重提",
    img: "https://readdy.ai/api/search-image?query=Lone%20person%20standing%20under%20warm%20street%20lamp%20at%20dusk%2C%20long%20shadow%2C%20retro%20cinematic%20tone%2C%20editorial%20storytelling%2C%20contemplative%20atmosphere&width=1200&height=750&seq=feed06&orientation=landscape",
  },
  {
    id: "f07",
    cat: "主播",
    title: "工作室回应「分家」传闻：语气里的机锋网友都懂",
    excerpt: "一段十几秒的声明，被解读出三层意思。团队分手背后的利益账，粉丝看得比谁都明白。",
    heat: "58.9万",
    time: "8小时前",
    tag: "工作室声明",
    img: "https://readdy.ai/api/search-image?query=Two%20silhouetted%20people%20at%20opposite%20ends%20of%20a%20long%20conference%20table%2C%20warm%20low%20key%20lighting%2C%20editorial%20corporate%20drama%2C%20moody%20cinematic%20grain&width=1200&height=750&seq=feed07&orientation=landscape",
  },
  {
    id: "f08",
    cat: "网红",
    title: "「素人涨粉百万」背后：到底有没有推手在点火",
    excerpt: "一夜涨粉的数据很性感，背后的投放单却没人敢晒。我们把涨粉曲线拉到分钟级，答案慢慢浮现。",
    heat: "89.2万",
    time: "9小时前",
    tag: "数据起底",
    img: "https://readdy.ai/api/search-image?query=Analytics%20charts%20and%20growing%20line%20graph%20over%20warm%20paper%20background%2C%20financial%20data%20aesthetic%2C%20editorial%20clean%20flat%20composition%2C%20soft%20shadows&width=1200&height=750&seq=feed08&orientation=landscape",
  },
  {
    id: "f09",
    cat: "明星",
    title: "红毯名场面重看：那个表情包背后的故事",
    excerpt: "全网都在刷的表情包，原视频只有三秒。当时到底发生了什么，让镜头前的他露出那种表情。",
    heat: "167.5万",
    hot: true,
    time: "11小时前",
    tag: "名场面",
    img: "https://readdy.ai/api/search-image?query=Red%20carpet%20with%20cameras%20and%20flashes%20at%20night%20event%2C%20empty%20center%20stage%2C%20warm%20golden%20spotlights%2C%20editorial%20glamour%2C%20cinematic%20bokeh&width=1200&height=750&seq=feed09&orientation=landscape",
  },
];

export const feedColumns = [
  { id: "col-a", title: "吃瓜头条", note: "实时滚动" },
  { id: "col-b", title: "争议发酵", note: "越挖越深" },
];

export const feedPicks = {
  a: feedItems.filter((_, i) => i % 2 === 0),
  b: feedItems.filter((_, i) => i % 2 !== 0),
};

export const deepTopics = [
  {
    id: "d01",
    cat: "人物纵深",
    title: "「全网喊冤」的她，为何越洗越黑",
    summary: "一场声势浩大的「反转」行动，非但没洗白，反而把更多旧事顶上热搜。我们梳理了时间线、证据链与粉丝舆论的三方拉扯。",
    read: "12 分钟",
    heat: "288万",
    accent: true,
    img: "https://readdy.ai/api/search-image?query=Editorial%20collage%20of%20newspaper%20clippings%20with%20a%20single%20spotlight%20in%20center%2C%20warm%20amber%20tone%2C%20mystery%20investigation%20mood%2C%20texture%20and%20layers&width=1200&height=750&seq=deep01&orientation=landscape",
  },
  {
    id: "d02",
    cat: "疑点拆解",
    title: "一张截图能定生死的时代，我们如何辨真伪",
    summary: "PS、AI换脸、断章取义……假证据满天飞。本期把常见的「实锤」套路摊开，教你看懂哪些该信、哪些该存疑。",
    read: "9 分钟",
    heat: "154万",
    accent: false,
    img: "https://readdy.ai/api/search-image?query=Fragmented%20glass%20shattering%20revealing%20pixels%20behind%2C%20concept%20of%20truth%20and%20fake%2C%20warm%20editorial%20minimal%20background%2C%20high%20contrast%2C%20digital%20texture&width=1200&height=750&seq=deep02&orientation=landscape",
  },
  {
    id: "d03",
    cat: "行业观察",
    title: "翻红流量密码：为什么越有争议越有人追",
    summary: "从「人设」到「人设崩塌」，从爆红到翻车，争议为何总能让数据更上一层楼？聊聊平台算法与大众心理的那点事。",
    read: "10 分钟",
    heat: "97万",
    accent: false,
    img: "https://readdy.ai/api/search-image?query=Fingerprint%20on%20glowing%20phone%20screen%20at%20night%2C%20algorithm%20social%20media%20concept%2C%20warm%20neon%20glow%2C%20editorial%20macro%2C%20cinematic&width=1200&height=750&seq=deep03&orientation=landscape",
  },
];

export const traceCases = [
  {
    id: "t01",
    name: "「白屿案」",
    kind: "当事人追踪",
    status: "回应中",
    desc: "围绕「白屿」的身份背景与一连串争议，事件仍在持续发酵，当事人已两次发声。",
    steps: [
      { time: "09.02", txt: "首张爆料帖出现，迅速冲上热榜" },
      { time: "09.04", txt: "多方旧图与聊天记录被陆续晒出" },
      { time: "09.06", txt: "当事人首次发声：「清者自清」" },
      { time: "09.08", txt: "二轮回应措辞软化，舆论开始分化" },
    ],
    dots: 3,
  },
  {
    id: "t02",
    name: "「黎九带货门」",
    kind: "事件还原",
    status: "已辟谣",
    desc: "疑似虚假宣传引发争议，后经多方核实与平台介入，部分指控被推翻，事件告一段落。",
    steps: [
      { time: "08.28", txt: "带货直播片段被质疑夸大宣传" },
      { time: "08.30", txt: "舆论发酵，相关话题登上热搜" },
      { time: "09.01", txt: "平台介入核查，出具初步结论" },
      { time: "09.05", txt: "部分指控被证伪，博主已发声明" },
    ],
    dots: 4,
  },
];

export const comments = [
  {
    id: "c01",
    name: "摸鱼吃瓜人",
    role: "铁杆吃瓜",
    cat: "站方圆桌",
    text: "建议大家先别急着站队，有些「实锤」其实经不起逐帧看。等证据链齐了再下结论也不迟。",
    likes: 1280,
    level: "热评",
    time: "16分钟前",
  },
  {
    id: "c02",
    name: "南巷以北",
    role: "围观群众",
    cat: "今日议题",
    text: "我专门回去看了原视频，节奏被带得挺明显的。这一波到底谁在带节奏，评论区早就真相了。",
    likes: 864,
    level: "热评",
    time: "31分钟前",
  },
  {
    id: "c03",
    name: "一颗大白兔",
    role: "真相党",
    cat: "当事人档案",
    text: "当事人之前那条动态真的没删干净，后手料太多。这瓜还能再挖好几层，坐等更新。",
    likes: 611,
    level: "热议",
    time: "44分钟前",
  },
];

export const hotTags = ["塌房", "翻红", "连麦剧本", "素人爆火", "旧账重提", "带货翻车", "逐帧实锤", "团队内讧"];